import React from 'react';

const UpgradeNudgeTaskLimit = () => (
  <svg fill="none" width="100%" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
      <path
        d="M0 15C0 9.47715 4.47715 5 10 5H414C419.523 5 424 9.47715 424 15V145C424 150.523 419.523 155 414 155H10C4.47715 155 0 150.523 0 145V15Z"
        fill="white"
      />
    </g>
    <rect
      fill="#E52F00"
      height="20"
      rx="10"
      transform="matrix(1 0 0 -1 30 105)"
      width="325"
    />
    <rect
      fill="#E52F00"
      height="20"
      rx="10"
      transform="matrix(1 0 0 -1 30 105)"
      width="269.286"
    />
    <rect
      fill="#F2F2F2"
      height="15"
      rx="2"
      transform="matrix(1 0 0 -1 30 70)"
      width="130"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="170"
        id="filter0_d"
        width="444"
        x="-10"
        y="0"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default UpgradeNudgeTaskLimit;
